module.exports = __webpack_public_path__ + "static/img/bioinformatics.f27ca0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bioinformatics.png
// module id = l4VW
// module chunks = 1